<template>
  <div class="errPage-container">
    <el-row>
      <el-col :span="12">
        <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream." />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import errGif from '@/assets/errorImages/401.gif'

export default {
  data() {
    return {
      errGif: `${errGif}?${+new Date()}`
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.errPage-container {
  margin: 100px auto;
  width: 800px;
}
</style>
